import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './BarraPesquisa.css';

import SelectStyles from "./json/selectStyles";
import RestApi from "./module/restApi";
import Mask from "./module/Mask";
import Select from 'react-select';

import * as _ from "lodash";

export default class BarraPesquisa extends Component {
	constructor(props){
		super(props);
		this.state = {	
            cities: [],
			therapies: [],
            selectedCity: null,
            selectedTherapy: null,
            awaitingFilter: false
        }
	}

  	componentDidMount() {
        this.getCities();
        this.getTherapies();
    }

    getCities(){
        RestApi.GetProfessionalDetailsList().then((data) => {
            let arr = data.professionals.filter(p => p.Address && !_.isEmpty(Mask.normalizeTextToCompare(p.Address.City))).map(p => {
                return { value: Mask.normalizeTextToCompare(p.Address.City), label: p.Address.City }
            })
			this.setState({ cities: _.sortedUniqBy(_.sortBy(arr, 'value'), 'value') })
		}).catch((e) => console.log("erro", e))	
    }

    getTherapies(){
        this.setState({awaitingFilter: true});
		RestApi.GetTherapies().then((data) => {
			let arr = data.therapies.map(t => {
                return { value: Mask.normalizeTextUrl(t.Name), label: t.Name } 
            });
			this.setState({therapies: arr, awaitingFilter: false});
		}).catch((e) => {            
			this.setState({awaitingFilter: false});
            console.log("erro", e);
        })
    }
    
    onChangeCity(val){        
        this.setState({selectedCity: val});
    }

    onChangeTherapy(val){
        this.setState({selectedTherapy: val});
    }
    
	render(){
		return(
            <div className="w-100">
                <div className="background-component" style={{minHeight: '650px'}}>
                    <div className="card bg-transparent border-0 p-3 w-100">
                        <div className="card-header bg-transparent text-white border-0">
                            <h1 className="display-2 font-weight-bolder m-0">ENCONTRE A <br/>TERAPIA IDEAL</h1>
                            <h1 className="m-0">CORPO, MENTE E ALMA</h1>
                        </div>
                        <div className="card-body">
                            <div className="row m-0">
                                <div className="col-md-4 col-sm-12 p-0 mb-2">
                                    <Select
                                        name="filtro_cidade"
                                        className="mr-md-2"
                                        classNamePrefix="select"                        
                                        placeholder={this.state.awaitingFilter ? <div className="spinner-border spinner-border-sm text-holos" role="status"><span className="sr-only">Loading...</span></div> : "Selecione a cidade"}
                                        styles={SelectStyles}
                                        options={this.state.cities}
                                        value={this.state.selectedCity}
                                        onChange={val => this.onChangeCity(val)}
                                    />
                                </div>                        
                                <div className="col-md-4 col-sm-12 p-0 mb-2">    
                                    <Select
                                        name="filtro_terapia"
                                        className="mr-md-2"
                                        classNamePrefix="select"
                                        placeholder={this.state.awaitingFilter ? <div className="spinner-border spinner-border-sm text-holos" role="status"><span className="sr-only">Loading...</span></div> : "Selecione uma técnica"}
                                        styles={SelectStyles}
                                        options={this.state.therapies} 
                                        value={this.state.selectedTherapy}
                                        onChange={val => this.onChangeTherapy(val)} 
                                    />
                                </div>                        
                                <div className="col-md-2 col-sm-12 p-0">
                                    <a 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        href={`http://sistema.holos.com.br/${
                                            this.state.selectedCity ? 
                                                this.state.selectedTherapy ? 
                                                    `?city=${Mask.normalizeTextUrl(this.state.selectedCity.label)}&therapy=${this.state.selectedTherapy.value}` 
                                                :   `?city=${Mask.normalizeTextUrl(this.state.selectedCity.label)}` 
                                            : this.state.selectedTherapy ? 
                                                `?therapy=${this.state.selectedTherapy.value}` 
                                                :   ''}`} className="text-decoration-none"
                                        >                         
                                        <button type="button" className="btn btn-holos btn-block" style={{height: '50px'}}><i className="fas fa-search"/> Pesquisar</button>
                                    </a> 
                                </div> 
                                <div className="col-sm-2 col-xs-12 p-0">
                                </div>
                            </div>                                         
                        </div>  
                    </div>                   	
                </div>
            </div>
		);
  	}
}
